import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AzureDebugInterceptor implements HttpInterceptor {
  externalAPiList = ['api.what3words.com', `thingproxy.freeboard.io`, 'www.googleapis.com'];

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request);
  }
}
